import {createApp} from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import api from "./api.js"
import 'material-icons/iconfont/material-icons.css';

// import jshelper from "./assets/js/helper"
import helper from "./assets/helper/validators"
import NotificationService from "./notification-service.js"
// import getData from "./assets/js/helper.js";
import AnimationHelper from "./assets/js/animation-helper.js";
//import material-icon scss
// import VueScrollmagic from 'vue-scrollmagic'

NotificationService.start();
api.defaults.timeout = 10000;
api.interceptors.request.use(
    (config) => {
        const token = `Bearer ${localStorage.getItem("user_auth_token")}`;
        if (token) {
            config.headers.common["Authorization"] = token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
api.interceptors.response.use(
    (response) => {
        if (response.status === 200 || response.status === 201) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    (error) => {
        if (error.response.status) {
            switch (error.response.status) {
                case 400:
                    break;
                case 401:
                    break;
                case 403:
                    break;
                case 404:
                    break;
                case 502:
                    return Promise.reject(error.response);
            }
        }
    }
);
// const router = createRouter({
//     history: createWebHashHistory(),
//     routes: [...],
//     scrollBehavior (to, from, savedPosition) {
//         // return desired position
//     }
// };

const appInstance = createApp(App);
appInstance.config.globalProperties.$anim = AnimationHelper;

// appInstance.use(getData);

// appInstance.component('micon', require('vue-materials-icon/MaterialIcon').default);
appInstance.provide('$http', api);
appInstance.provide('$helper', helper);
appInstance.use(store);
appInstance.use(router);
// appInstance.use(VueScrollmagic)
appInstance.use(ArgonDashboard);
appInstance.config.globalProperties.notificationEmitter = NotificationService.notification_emitter;
appInstance.config.globalProperties.nene = "hello";
appInstance.mount("#app");
appInstance.config.devtools = true;


//https://stackoverflow.com/questions/63471824/vue-js-3-event-bus
